// extracted by mini-css-extract-plugin
export default {"wrapper":"MC","noPadding":"NC","flavor_wrapper":"OC","flavor_button":"PC","vert":"QC","itemContent":"RC","itemName":"SC","blue":"TC","out_of_stock":"UC","newFlavorBadge":"VC","fullWidth":"WC","flavor_button_selected":"XC","black":"YC","attribute_wrapper":"ZC","toggle_wrapper":"aE"};
    if(module.hot) {
      // 1726593106243
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  